export enum FiltersActions {
    SET_SEARCH_PHRASE = "filter",
    TOGGLE_FILTRATION = "toggleFiltration",
    CLEAR = "clear",
    SET_SORTING = "setSorting",
    SET_FINISHED = "setFinished"
  }